import { Collapse } from '@blueprintjs/core';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ShowIf, validatable } from 'components/utils';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router';
import ListDonDoc from './ListDonDoc.jsx';
import ListLanNopTien from './ListLanNopTien.jsx';
import NoiDungKienNghiDoiTuongThanhTra from './NoiDungKienNghiDoiTuongThanhTra.jsx';
import style from './style.scss';

class DoiTuongKienNghiView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataDetail: {},
      id: this.props.id,
      style: style,

      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      enableTheoDoi: false,
      enableDonDoc: false,
      enableKiemTra: false,

      linhVucThanhTra: this.props.linhVucThanhTra,
      listDoiTuongViPham: this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: this.props.chucNangCuocThanhTra,
    }
  }

  componentDidMount() {
    this.checkProcess(this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      linhVucThanhTra: nextProps.linhVucThanhTra,
    })
    if (nextProps.data != this.props.data) {
      this.checkProcess(nextProps.data);
    }
  }

  checkProcess(data) {
    let DataDetail = data;
    if (DataDetail.ngayBatDauKiemTra != null) {
      this.setState({
        enableTheoDoi: true,
        enableDonDoc: true,
        enableKiemTra: true
      })
    } else if (DataDetail.donDocDoiTuongs.length > 0) {
      this.setState({
        enableTheoDoi: true,
        enableDonDoc: true,
        enableKiemTra: false
      })
    } else {
      this.setState({
        enableTheoDoi: true,
        enableDonDoc: false,
        enableKiemTra: false
      })
    }
  }

  closeDialog() {
    this.props.closeDialog();
  }

  handleCollapse(name) {
    this.setState({
      [name]: !this.state[name]
    })
  }

  render() {
    let DataDetail = this.props.data;
    return (
      <section className="wrap-dtkn">
        <ShowIf condition={this.props.toChucLienQuan != true}>
          <div className='content-dtkn'>
            <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungKienNghi ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungKienNghi')}>1. Nội dung kiến nghị</Link></h2>
            <Collapse isOpen={this.state.showNoiDungKienNghi}>
              <NoiDungKienNghiDoiTuongThanhTra linhVucThanhTra={this.state.linhVucThanhTra} chucNangCuocThanhTra={this.state.chucNangCuocThanhTra} {...DataDetail} />
            </Collapse>
          </div>
        </ShowIf>
        <ShowIf condition={this.state.enableTheoDoi}>
          <div>
            <div className='big-border' />
          </div>
          <div className='content-dtkn'>
            <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungTheoDoi ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungTheoDoi')}>{`${this.props.toChucLienQuan == true ? '1' : '2'}. Theo dõi thực hiện`}</Link></h2>
            <Collapse isOpen={this.state.showNoiDungTheoDoi}>
              <div className='pl15 pr15'>
                <div className='col-100 no-gutter'>
                  <h2 className='title-12 mb10 mt15'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.1. Xử lý thu hồi`}</h2>
                  <div className='col-50 no-gutter'>
                    <h2 className='txt-bold txt-upper col-100 mb10'>Thu hồi về NSNN</h2>
                    <Text className='col-50 mb10' label='Đã thu tiền (đ):' value={DataDetail.theoDoiTienDaThuHoiVeNganSachNhaNuoc} />
                    <Text className='col-50 mb10' label='Đã thu đất đất (m2):' value={DataDetail.theoDoiDatDaThuHoiVeNganSachNhaNuoc} />
                  </div>
                  <div className='col-50 no-gutter'>
                    <h2 className='txt-bold txt-upper col-100 mb10'>Thu hồi về tổ chức, đơn vị</h2>
                    <Text className='col-50 mb10' label='Đã thu tiền (đ):' value={DataDetail.theoDoiTienDaThuTrongQuaTrinhThanhTra} />
                    <Text className='col-50 mb10' label='Đã thu đất (m2):' value={DataDetail.theoDoiDatDaThuTrongQuaTrinhThanhTra} />
                  </div>
                </div>
                <div className='mb20 mt5'>
                  <div className='line-border' />
                </div>

                <h2 className='title-12 mb10'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.2. Xử lý về kinh tế`}</h2>
                <div className='row pl10 pr10'>
                  <Text className='col-25 mb10' label='Tổng số tiền phải thu hồi (đ):' value={DataDetail.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : ''} />
                  {/*list lần nộp tiền*/}
                  <ListLanNopTien data={DataDetail.listTheoDoiLanNopTien} view={true} />
                  {/*End*/}
                  <TextMessage className='col-100 mb10' label='Lý do' value={DataDetail.lyDoThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.lyDoThuHoiTheoDoiXuLyVeKinhTe : ''} />

                  <h2 className='col-100 mb10 mt5 txt-bold txt-upper txt-12'>Sai phạm về đất đai kiến nghị thu hồi</h2>
                  <Text className='col-25 mb10' label='Phải thu (m2):' value={DataDetail.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Đã thu (m2):' value={DataDetail.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : ''} />
                  <Text className='col-25 mb10' label='Còn phải thu (m2):' value={DataDetail.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : ''} />
                  <TextMessage className='col-100 mb10' label='Lý do:' value={DataDetail.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? DataDetail.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : ''} />

                  <h2 className='col-100 mb10 mt5 txt-bold txt-upper txt-12'>Sai phạm khác</h2>
                  <TextMessage className='col-100 mb10' label='Nội dung sai phạm khác:' value={DataDetail.saiPhamKhacTheoDoiXuLyVeKinhTe ? DataDetail.saiPhamKhacTheoDoiXuLyVeKinhTe : ''} />
                </div>
                <div className='mb20 mt5'>
                  <div className='line-border' />
                </div>

                <h2 className='title-12 mb10'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.3. Xử lý về hành chính`}</h2>
                <div className='row pl10 pr10'>
                  <Text className='col-100 mb10' label='Số quyết định xử lý hành chính:' value={DataDetail.soQuyetDinhTheoDoiXuLyHanhChinh ? DataDetail.soQuyetDinhTheoDoiXuLyHanhChinh : ''} />
                  <Text className='col-25 mb10' label='Tổ chức có sai phạm:' value={DataDetail.theoDoiToChucCoSaiPham ? DataDetail.theoDoiToChucCoSaiPham : ''} />
                  <Text className='col-25 mb10' label='Bằng tiền:' value={DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangTien : ''} />
                  <Text className='col-50 mb10' label='Bằng hình thức khác:' value={DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? DataDetail.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : ''} />

                  <Text className='col-25 mb10' label='Cá nhân có sai phạm:' value={DataDetail.theoDoiCaNhanCoSaiPham ? DataDetail.theoDoiCaNhanCoSaiPham : ''} />
                  <Text className='col-25 mb10' label='Bằng tiền:' value={DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : ''} />
                  <Text className='col-50 mb10' label='Bằng hình thức khác:' value={DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? DataDetail.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : ''} />
                </div>
                <div className='mb20 mt5'>
                  <div className='line-border' />
                </div>

                <h2 className='title-12 mb10'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.4. Xử lý về hình sự`}</h2>
                <div className='row pl10 pr10'>
                  <Text className='col-25 mb10' label='Văn bản đôn đốc cơ quan điều tra:' value={DataDetail.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? DataDetail.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : ''} />
                  <Text className='col-25 mb10' label='Kết quả chuyển cơ quan điều tra:' value={DataDetail.ketQuaChuyenCoQuanDieuTraInfo ? DataDetail.ketQuaChuyenCoQuanDieuTraInfo.text : ''} />
                  <Text className='col-25 mb10' label='Số vụ việc:' value={DataDetail.soVuViecTheoDoiXuLyHinhSu ? DataDetail.soVuViecTheoDoiXuLyHinhSu : ''} />
                </div>
                <div className='row pl10 pr10'>
                  <Text className='col-100 mb10' label='Số đối tượng:' value={DataDetail.soDoiTuongTheoDoiXuLyHinhSu ? DataDetail.soDoiTuongTheoDoiXuLyHinhSu : ''} />
                  <TextMessage className='col-100 mb10' label='Ghi chú:' value={DataDetail.ghiChuTheoDoiXuLyHinhSu ? DataDetail.ghiChuTheoDoiXuLyHinhSu : ''} />
                </div>

                <div className='mb20 mt5'>
                  <div className='line-border' />
                </div>
                <h2 className='title-12 mb10'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.5. Kiến nghị hoàn thiện cơ chế chính sách`}</h2>
                <div className='row pl10 pr10'>
                  <Text className='col-30 mb10' label='Số kiến nghị đã thực hiện xong:' value={DataDetail.soKienNghiDaThucHienXong} />
                </div>

                <div className='mb20 mt5'>
                  <div className='line-border' />
                </div>
                <h2 className='title-12 mb10'>{`${this.props.toChucLienQuan == true ? '1' : '2'}.6. Xử lý khác`}</h2>
                <div className='row pl10 pr10'>
                  <Text className='col-25 mb10' label='Kiến nghị tiền (đ):' value={DataDetail.kienNghiTienTheoDoiXuLyKhac ? DataDetail.kienNghiTienTheoDoiXuLyKhac : ''} />
                  <Text className='col-25 mb10' label='Kiến nghị đất (m2):' value={DataDetail.kienNghiDatTheoDoiXuLyKhac ? DataDetail.kienNghiDatTheoDoiXuLyKhac : ''} />
                  <TextMessage className='col-100 mb10' label='Kết quả thực hiện kiến nghị khác:' value={DataDetail.ketQuaThucHienTheoDoiXuLyKhac ? DataDetail.ketQuaThucHienTheoDoiXuLyKhac : ''} />
                </div>
              </div>
            </Collapse>
          </div>
        </ShowIf>

        <ShowIf condition={this.state.enableDonDoc}>
          <div>
            <div className='big-border' />
          </div>
          <div className='content-dtkn custom-collapse'>
            <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungDonDoc ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungDonDoc')}>{`${this.props.toChucLienQuan == true ? '2' : '3'}. Đôn đốc`}</Link></h2>
            <Collapse isOpen={this.state.showNoiDungDonDoc}>
              <ListDonDoc toChucLienQuan={this.props.toChucLienQuan} bindValidator={this} view={true} id={DataDetail.doiTuongViPhamId} onRef={donDoc => (this.donDoc = donDoc)} />
            </Collapse>
          </div>
        </ShowIf>

        <ShowIf condition={this.state.enableKiemTra}>
          <div>
            <div className='big-border' />
          </div>
          <div className='content-dtkn custom-collapse'>
            <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungKiemTra ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungKiemTra')}>{`${this.props.toChucLienQuan == true ? '3' : '4'}. Kiểm Tra`}</Link></h2>
            <Collapse isOpen={this.state.showNoiDungKiemTra}>
              <div className='pl15 pr15 pt15'>
                <div className='row pl10 pr10'>
                  <Text className='col-25 mb10' label='Số quyết định:' value={DataDetail.soQuyetDinhKiemTra ? DataDetail.soQuyetDinhKiemTra : ''} />
                  <Text className='col-25 mb10' label='Ngày ban hành:' value={DataDetail.ngayBanHanhKiemTra ? moment(DataDetail.ngayBanHanhKiemTra).format('DD/MM/YYYY') : ''} />
                  <Text label='Ngày bắt đầu' className='col-25 mb10:' value={DataDetail.ngayBatDauKiemTra ? moment(DataDetail.ngayBatDauKiemTra).format('DD/MM/YYYY') : ''} />
                  <Text label='Thời hạn kiểm tra (ngày làm việc):' className='col-25 mb10' value={`${DataDetail.thoiHanKiemTra ? DataDetail.thoiHanKiemTra : 0} ngày (${DataDetail.ngayHetHanKiemTra ? moment(DataDetail.ngayHetHanKiemTra).format('DD/MM/YYYY') : ''})`} />

                  <TextMessage className='col-100 mb10' label='Căn cứ kiểm tra:' value={DataDetail.canCuKiemTra ? DataDetail.canCuKiemTra : ''} />
                  <TextMessage className='col-100 mb10' label='Tình hình kiểm tra:' value={DataDetail.tinhHinhKiemTra ? DataDetail.tinhHinhKiemTra : ''} />
                  <Text className='col-25 mb10' label='Kết luận về nội dung kiểm tra:' value={DataDetail.ketQuaKiemTraInfo ? DataDetail.ketQuaKiemTraInfo.text : ''} />
                </div>
              </div>
            </Collapse>
          </div>
        </ShowIf>

        <div className='content-dtkn pl15 pr15 pb10'>
          <ShowIf condition={this.state.showFile}>
            <ContainerFileDinhKem
              hideDescription={true}
              disableAttachFile={true}
              label="Danh sách văn bản xử lý"
              dataShow={DataDetail.listTaiLieuVanThu} />
          </ShowIf>
        </div>
        <div>
          <div className='pr10 pl10'>
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}><span>Đóng</span></Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

DoiTuongKienNghiView.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: '',
  listDoiTuongViPham: []
}

export default validatable(DoiTuongKienNghiView);


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DoiTuongKienNghiView.jsx